//
window.mustacheUi = (function () {
    function publicToHtml(model, targetSelector, templateSelector) {
        var e;
        var html;
        var template;
        var json;
        var viewModel = JSON.stringify(model);

        try {
            template = $(templateSelector).html();
            json = JSON.parse(viewModel);
            html = window.Mustache.to_html(template, json).replace(/^\s*/mg, '');
        } catch (error) {
            e = error;
            html = e.toString();
        }

        $(targetSelector).html(html);
    }

    return {
        // Public_methods
        toHtml: publicToHtml
    };
})();
